import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { YourDetailsVariable } from 'enums/LoanFormVariables';

export interface YourDetailInterface {
  [YourDetailsVariable.AddressLine1]: string;
  [YourDetailsVariable.AddressLine2]: string;
  [YourDetailsVariable.City]: string;
  [YourDetailsVariable.ZipCode]: string;
  [YourDetailsVariable.ArgyleState]: string;
}

export const initialState: YourDetailInterface = {
  [YourDetailsVariable.AddressLine1]: '',
  [YourDetailsVariable.AddressLine2]: '',
  [YourDetailsVariable.City]: '',
  [YourDetailsVariable.ZipCode]: '',
  [YourDetailsVariable.ArgyleState]: '',
};

const yourDetails = createSlice({
  name: 'yourDetails',
  initialState,
  reducers: {
    setYourDetailsData: (state: YourDetailInterface, { payload }: PayloadAction<YourDetailInterface>) => {
      state[YourDetailsVariable.AddressLine1] = payload[YourDetailsVariable.AddressLine1];
      state[YourDetailsVariable.AddressLine2] = payload[YourDetailsVariable.AddressLine2];
      state[YourDetailsVariable.City] = payload[YourDetailsVariable.City];
      state[YourDetailsVariable.ZipCode] = payload[YourDetailsVariable.ZipCode];
      state[YourDetailsVariable.ArgyleState] = payload[YourDetailsVariable.ArgyleState];
      analytics.identify({
        address: [
          payload[YourDetailsVariable.AddressLine1],
          payload[YourDetailsVariable.AddressLine2],
          `${payload[YourDetailsVariable.City]}, ${payload[YourDetailsVariable.ArgyleState]} ${
            payload[YourDetailsVariable.ZipCode]
          }`,
        ]
          .filter((line) => line)
          .join('\n'),
      });
    },
  },
});

export const { setYourDetailsData } = yourDetails.actions;

export default yourDetails.reducer;
